import React, { Component, Fragment } from 'react';
import { Card, CardBody, Row, Col, Button } from 'reactstrap';

class ClinicNotesHistoryComplete extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <>
                <Fragment>
                    {this.props.notas_clinicas.length > 0 ?
                        <Fragment>

                            <h4 style={{ marginTop: 20, marginBottom: 10 }} > Notas Clínicas</h4>
                            <hr />
                            <Row style={{ marginTop: 10 }}>

                                {this.props.notas_clinicas.map((nota) => {
                                    return (
                                        <p>{nota.nota_clinica}</p>
                                    );
                                })}
                            </Row>
                        </Fragment>
                        : null
                    }
                </Fragment>
            </>
        );
    }
}

export default ClinicNotesHistoryComplete;
